import { get, post } from '@src/services/NetworkUtils'

// Company-scoped money/commercial surfaces introduced with the Rupiah wallet
// (BR-SALDO) and the tier x periode x golongan pricing model (BR-SUB/BR-PRICE).
//
// Deliberately separate from BillingService: those endpoints are the QUOTA-unit
// world (balance = counts, topup = buying units). The wallet is Rupiah. Mixing
// them in one service object is how "saldo" came to mean two different things.

export const WalletService = {
  // { balance_idr, held_idr, expires_at, net_price_idr, estimated_requests,
  //   free_quota, free_quota_expires_at, topup_headroom_idr, ... }
  getWallet: (companyId) => get(`/v1/companies/${companyId}/wallet`),
  // { data, paginator } — the BR-SALDO-26 statement.
  getTransactions: (companyId, params) =>
    get(`/v1/companies/${companyId}/wallet/transactions`, params),
}

export const PricingService = {
  // What this company is charged right now: { golongan_usaha, package,
  //   tarif_enquiry_idr, can_request, legacy_subscription, ... }
  resolve: (companyId) => get(`/v1/companies/${companyId}/pricing/resolve`),
  // Catalog, already scoped server-side to the company's golongan.
  listPackages: (companyId, params) =>
    get(`/v1/companies/${companyId}/pricing/packages`, params),
  quote: (companyId, params) => get(`/v1/companies/${companyId}/pricing/quote`, params),
}

export const GolonganService = {
  getStatus: (companyId) => get(`/v1/companies/${companyId}/golongan`),
  // Submitting never blocks anything: the company stays Korporat and keeps
  // transacting at Korporat prices while it waits (BR-SUB-07 poin 2).
  apply: (companyId) => post(`/v1/companies/${companyId}/golongan/apply`),
  // Only possible while pending_review — once a reviewer picks it up the
  // company must wait for the verdict.
  cancel: (companyId) => post(`/v1/companies/${companyId}/golongan/cancel`),
}
